import React from "react"
import AdminContainer from "../../components/Admin/AdminContainer"

const AdminPage = () => {
  return <AdminContainer />
}

export default AdminPage
